import { POEMS } from "./poems.data";

const INITIAL_STATE = {
  poems: POEMS,
};

const poemsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default poemsReducer;
